// /* @flow */
import produce from 'immer'

export default function reducer(state, action: any) {
  const initialState = action.__initialData.defaultProps
  return produce(state, draft => {
    switch (action.type) {
      case 'ADD_BLOCK':
        draft.blocks.push(initialState.blocks[0])
        break
      case 'CHANGE_TITLE':
        draft.title = action.value
        break
      case 'CHANGE_PARAGRAPH':
        draft.paragraph = action.value
        break
      case 'CHANGE_BLOCK_TITLE':
        const { newTitle, idx } = action.value
        draft.blocks[idx].title = newTitle
        break
      case 'CHANGE_TITLE_ALIGNMENT': {
        draft.titleAlignment = action.value
        break
      }
      case 'CHANGE_BLOCK_TITLE_ALIGNMENT': {
        const { idx, alignment } = action.value
        draft.blocks[idx].blockTitleAlignment = alignment
        break
      }
      case 'CHANGE_PARAGRAPH_ALIGNMENT': {
        draft.paragraphAlignment = action.value
        break
      }
      case 'REMOVE_BLOCK':
        const { idx: idx__ } = action.value
        draft.blocks.splice(idx__, 1)
        break
      case 'CHANGE_LINK_DATA':
        const { linkIdx, linkData } = action.value
        draft.blocks[linkIdx].additionalUrl = linkData.link
        draft.blocks[linkIdx].additionalText = linkData.text
        break
      case 'CHANGE_ICON':
        const { idx: idx_, iconName } = action.value
        draft.blocks[idx_].iconName = iconName
        break
      case 'REMOVE_LINK': {
        const { idx } = action.value
        draft.blocks[idx].additionalUrl = ''
        draft.blocks[idx].additionalText = ''
        break
      }
      case 'REMOVE_ICON': {
        const { idx } = action.value
        draft.blocks[idx].icon = ''
        break
      }
      case 'ADD_ICON':
        draft.blocks[action.value].icon = 'edit'
        break
      case 'ADD_LINK': {
        const { additionalUrl, additionalText } = initialState.blocks[0]
        const { idx } = action.value
        draft.blocks[idx].additionalUrl = additionalUrl
        draft.blocks[idx].additionalText = additionalText
        break
      }
    }
  })
}
